import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { UPDATE_PROFILE } from 'root/src/shared/descriptions/endpoints/endpointIds'
import updateProfile from 'root/src/client/logic/profile/actions/updateProfile'

export default image => async (dispatch) => {
	const res = await dispatch(apiRequest(UPDATE_PROFILE, { image }))
	dispatch(updateProfile(res.body))
}
